import { getTimeZones } from "../api/SelectApi"
import InputSelect from "./InputSelect"

import { tr } from "../i18n";
const TimeZoneSelect = (props) => {

    const data = {
        name: props.name || "timeZone",
        className: props.className,
        components: {},
        placeholder: tr("settings:type_for_load_more_time_zone"),
        options : [],
        rules: props.rules,
        defaultValue: props.defaultValue
    }

    async function handleData(search = ''){
        const result = await fetchTimeZones(search);
        
        return result;
    }

    const fetchTimeZones = async (keyword = '') => {
        try {
            const results = await getTimeZones(keyword);
            
            return results.data.map((data) => ({
                label: String(data.text),
                value: String(data.id),
            }));

        } catch (error) {
            console.error("Error fetching time zones", error);
            return [];
        }
    };

    return (
        <InputSelect props={props} data={data} handleOnLoadData={handleData}></InputSelect>
    )
}

export default TimeZoneSelect